import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { EActive, EBankStatus } from './enumTypes';
import httpClient from '../../api/httpClient';

export type TIntegrationData = {
  data: {
    createdAt: string;
    name: string;
    paramsId: string;
    status: EBankStatus;
  }[];
};

export const getIntregrations = createAsyncThunk<TIntegrationData>('intregration/get', async () => {
  try {
    const response = await httpClient.get('/api/v1/bank-connections').then((response) => {
      return response.data;
    });
    return await response;
  } catch (e) {
    return console.log('intregration/get error' + e);
  }
});

export const addIntegration = createAsyncThunk<
  { paramsId: string },
  { BankId: string; UserName: string; Password: string; ClientSecret: string; ExtClientId: string }
>('intregration/post', async (props) => {
  try {
    const response = await httpClient.post('/api/v1/bank-connections', props).then((response) => {
      return response.data;
    });
    return await response;
  } catch (e) {
    return console.log('intregration/post error' + e);
  }
});

export const deleteIntegration = createAsyncThunk<
  string,
  { paramsId: string }
>('intregration/delete', async ({ paramsId }) => {
  try {
    const response = await httpClient.delete(`/api/v1/bank-connections/${paramsId}`).then((response) => {

      return response.data;
    });
    return await response;
  } catch (e) {
    return console.log('intregration/delete error' + e);
  }
});

export const editIntegration = createAsyncThunk<
  { paramsId: string },
  Partial<{
    paramsId: string | null;
    isActive: EActive;
    userName: string;
    password: string;
    clientSecret: string;
    extClientId: string;
  }>
>('intregration/patch', async (props) => {
  const { paramsId, ...restProps } = props;
  try {
    const response = await httpClient.patch(`/api/v1/bank-connections/${paramsId}`, restProps).then((response) => {
      return response.data;
    });
    return await response;
  } catch (e) {
    return console.log('intregration/patch error' + e);
  }
});

interface IntregrationState {
  intregrations: TIntegrationData['data'] | null;
  paramsId: string | null;
  loading: boolean;
  error: boolean;
}

const initialState: IntregrationState = {
  intregrations: null,
  paramsId: null,
  loading: true,
  error: false,
};

export const intregrationSlice = createSlice({
  name: 'intregration',
  initialState,
  reducers: {
    setEditIntegrationId: (state, action) => {
      state.paramsId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getIntregrations.pending, (state) => {
      state.intregrations = null;
      state.paramsId = null;
    });
    builder.addCase(getIntregrations.fulfilled, (state, action) => {
      state.intregrations = action.payload.data;
      state.loading = false;
      state.error = false;
    });
    builder.addCase(getIntregrations.rejected, (state) => {
      state.loading = false;
      state.error = true;
    });
    builder.addCase(addIntegration.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.paramsId = action.payload.paramsId;
    });
    builder.addCase(addIntegration.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
    });
    builder.addCase(editIntegration.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.paramsId = action.payload.paramsId;
    });
    builder.addCase(editIntegration.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
    });
    builder.addCase(deleteIntegration.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.paramsId = action.payload;
    });
    builder.addCase(deleteIntegration.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
    });
  },
});

export default intregrationSlice.reducer;
